export enum StoreExpenseStatusEnum {
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  AWAITING_EVIDENCE = 'AWAITING_EVIDENCE',
  CANCELLED = 'CANCELLED',
  SENT_BACK = 'SENT_BACK'
}

export enum RefundReasonEnum {
  INCORRECT_DOCUMENT_OR_DETAIL = 'INCORRECT_DOCUMENT_OR_DETAIL',
  INCORRECT_EXPENSE_AMOUNT = 'INCORRECT_EXPENSE_AMOUNT',
  INCORRECT_REFUND_INFORMATION = 'INCORRECT_REFUND_INFORMATION'
}
